import Vue from "vue";
import App from "./App.vue";
import router from "./router";
//import lax from "lax.js";

Vue.config.productionTip = false;

//Vue.prototype.$lax = lax;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");